import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { StoreContext } from "../../../../Store/Provider";
import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";
import { HOST_URL } from "../../../../Config";
import axios from "axios";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import PropagateLoader from "react-spinners/PropagateLoader";
import LCL from "../../../SVG/LCL";
import FCL from "../../../SVG/FCL";
import BCN from "../../../SVG/BCN";
import LSE from "../../../SVG/LSE";
import Sea from "../../../SVG/Sea";
import Plane from "../../../SVG/Plane";
import RoadSVG from "../../../SVG/RoadSVG.js";
import CourierSVG from "../../../SVG/CourierSVG";
import RailSVG from "../../../SVG/RailSVG";
import PlaceDot from "../../../SVG/PlaceDot";
import Line from "../../../SVG/Line";
import InTransit from "../../../SVG/InTransit";
import Arrived from "../../../SVG/Arrived";
import PreLoaded from "../../../SVG/PreLoaded";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function SearchShipmentResult(props) {
  const classes = useStyles();
  const context = useContext(StoreContext);
  const [loading, setLoading] = useState(false);
  const [isData, setIsData] = useState(false);
  const history = useNavigate();
  const [openalert, setOpenalert] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };
  const [loadedData, setLoadedData] = useState({});

  useEffect(async () => {
    if (context.shipmentNo) {
      await getShipmentListing();
    } else {
      history(-1);
    }
  }, []);

  const getShipmentListing = async () => {
    setLoading(true);
    const end_point = `${HOST_URL}api/v1/Shipment/DETAILWL`;
    const params = {
      shipmentid: `${context.shipmentNo}`,
    };

    axios
      .post(end_point, params)
      .then((res) => {
        if (res.data.Success) {
          setLoadedData(res.data.Value);
          setIsData(true);
        } else {
          setIsData(false);
          setOpenalert(true);
          setTimeout(() => {
            history(-1);
          }, 2500);
        }
        setLoading(false);
      })
      .catch((err) => {
        setIsData(false);
        history(-1);
        setLoading(false);
      });
  };

  return (
    <div className="home">
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert severity="error" onClose={handleClose}>
          No Shipments Found!
        </Alert>
      </Snackbar>
      <Header shipmentNo={context.shipmentNo} />
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={
            ("menuBarDrawer",
            {
              paper: clsx(classes.drawerPaperleft, {
                [classes.drawerOpen]: context.menuBar,
                [classes.drawerClose]: !context.menuBar,
              }),
            })
          }
        >
          <Sidebar />
        </Drawer>
        <main className={clsx(classes.content)}>
          {loading ? (
            <div className="loadingClass">
              <PropagateLoader
                color={"rgba(var(--text-heading-dark))"}
                size={"1.5rem"}
              />
            </div>
          ) : (
            <div className="shipmentsListingHomeInner">
              <div className="shipmentsListingHomeInnerHeading">
                <span>Search Results</span>
                <CloseIcon
                  onClick={() => {
                    history(-1);
                  }}
                />
              </div>
              {isData && (
                <div className="shipmentSearchBody ">
                  <div
                    className="shipmentCardOuter shipmentCardOuterWithoutLogin"
                    style={{ cursor: "unset" }}
                  >
                    <div className="withoutloginSearchCardInner">
                      <div className="shpTypeDiv">
                        <div className="shpTypeCountDiv">
                          {loadedData?.ContainerCount
                            ? loadedData?.ContainerCount
                            : "N/A"}
                        </div>
                        <div className="shpType">
                          {loadedData?.ContainerMode === "LCL" ? (
                            <LCL colorCode={"rgba(var(--text-heading-dark))"} />
                          ) : loadedData?.ContainerMode === "FCL" ? (
                            <FCL colorCode={"rgba(var(--text-heading-dark))"} />
                          ) : loadedData?.ContainerMode === "BCN" ? (
                            <BCN colorCode={"rgba(var(--text-heading-dark))"} />
                          ) : loadedData?.ContainerMode === "LSE" ? (
                            <LSE colorCode={"rgba(var(--text-heading-dark))"} />
                          ) : null}
                          <p>{loadedData?.ContainerMode}</p>
                        </div>
                      </div>
                      <div className="shpDetailsDiv">
                        <div className="shpDetailsDivIdImg">
                          <div className="shpDetailsDivId">
                            <span>Shipment ID</span>
                            {/* <p>{loadedData?.ShipmentId}</p> */}
                            <p>{context.shipmentNo}</p>
                          </div>
                        </div>
                      </div>
                      <div className="shpDetailsRouteDiv">
                        <p className="etdEtap">
                          <span>
                            {loadedData?.ShipmentOriginETD
                              ? loadedData?.ShipmentOriginETD.split(" ")[0] ===
                                  "01/01/1900" ||
                                loadedData?.ShipmentOriginETD.split(" ")[0] ===
                                  "01/01/0001"
                                ? "N/A"
                                : loadedData?.ShipmentOriginETD.split(" ")[0]
                              : ""}
                          </span>
                          <span>
                            {loadedData?.ShipmentDestinationETA
                              ? loadedData?.ShipmentDestinationETA.split(
                                  " "
                                )[0] === "01/01/1900" ||
                                loadedData?.ShipmentDestinationETA.split(
                                  " "
                                )[0] === "01/01/0001"
                                ? "N/A"
                                : loadedData?.ShipmentDestinationETA.split(
                                    " "
                                  )[0]
                              : ""}
                          </span>
                        </p>
                        <div className="shptimelinebody">
                          <span title={loadedData.OriginPortName}>
                            {loadedData.OriginPort}
                          </span>
                          <div className="shptimelinecontainer">
                            <span>
                              {loadedData.TransportMode === "SEA" ? (
                                <Sea
                                  colorCode={"rgba(var(--text-heading-dark))"}
                                  seaClass={"shptimelinemode"}
                                />
                              ) : loadedData.TransportMode === "ROA" ? (
                                <RoadSVG
                                  colorCode={"rgba(var(--text-heading-dark))"}
                                  planeClass={"shptimelinemode"}
                                />
                              ) : loadedData.TransportMode === "COU" ? (
                                <CourierSVG
                                  colorCode={"rgba(var(--text-heading-dark))"}
                                  planeClass={"shptimelinemode"}
                                />
                              ) : loadedData.TransportMode === "RAI" ? (
                                <RailSVG
                                  colorCode={"rgba(var(--text-heading-dark))"}
                                  planeClass={"shptimelinemode"}
                                />
                              ) : loadedData.TransportMode === "AIR" ? (
                                <Plane
                                  colorCode={"rgba(var(--text-heading-dark))"}
                                  planeClass={"shptimelinemode"}
                                />
                              ) : null}
                            </span>
                            <span>
                              <PlaceDot
                                colorCode={"rgba(var(--text-heading-dark))"}
                              />
                            </span>
                            <Line
                              colorCode={"rgba(var(--text-heading-dark))"}
                              classDotted={"dottedline"}
                            />
                          </div>
                          <span title={loadedData?.DestinationPortName}>
                            {loadedData?.DestinationPort}
                          </span>
                        </div>
                      </div>
                      <div
                        className="locateDiv"
                        title={
                          loadedData.ShipmentStatus === 1
                            ? "Pre-loaded"
                            : loadedData.ShipmentStatus === 2
                            ? "Loaded"
                            : loadedData.ShipmentStatus === 3
                            ? "Arrived"
                            : ""
                        }
                      >
                        {loadedData.ShipmentStatus === 1 ? (
                          <PreLoaded
                            colorCode={"rgba(var(--text-heading-dark))"}
                          />
                        ) : loadedData.ShipmentStatus === 2 ? (
                          <InTransit
                            colorCode={"rgba(var(--text-heading-dark))"}
                          />
                        ) : loadedData.ShipmentStatus === 3 ? (
                          <Arrived
                            colorCode={"rgba(var(--text-heading-dark))"}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-12">
                        <div className="shpDetailsDivIdImg">
                          <div className="shpDetailsDivId">
                            <span>Volume</span>
                            <p
                              title={`${loadedData.TotalVolume} ${loadedData.TotalVolumeUQ}`}
                            >
                              {loadedData.TotalVolume
                                ? context.calculateAmmount(
                                    loadedData.TotalVolume
                                  )
                                : "N/A"}{" "}
                              {loadedData.TotalVolumeUQ}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-12">
                        <div className="shpDetailsDivIdImg">
                          <div className="shpDetailsDivId">
                            <span>Weight</span>
                            <p
                              title={`${loadedData.TotalWeight} ${loadedData.TotalWeightUQ}`}
                            >
                              {loadedData.TotalWeight
                                ? context.calculateAmmount(
                                    loadedData.TotalWeight
                                  )
                                : "N/A"}{" "}
                              {loadedData.TotalWeightUQ}
                            </p>
                          </div>
                        </div>
                      </div>
                      {loadedData.TransportMode === "ROA" ? (
                        <div className="col-md-6 col-12">
                          <div className="shpDetailsDivIdImg">
                            <div className="shpDetailsDivId">
                              <span>Truck No#</span>
                              <p>
                                {loadedData.Voyage ? loadedData.Voyage : "N/A"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : loadedData.TransportMode === "RAI" ? (
                        <div className="col-md-6 col-12">
                          <div className="shpDetailsDivIdImg">
                            <div className="shpDetailsDivId">
                              <span>Journey No#</span>
                              <p>
                                {loadedData.Voyage ? loadedData.Voyage : "N/A"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : loadedData.TransportMode !== "AIR" ? (
                        <div className="col-md-6 col-12">
                          <div className="shpDetailsDivIdImg">
                            <div className="shpDetailsDivId">
                              <span>Vessel</span>
                              <p>
                                {loadedData.Vessal ? loadedData.Vessal : "N/A"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {loadedData.TransportMode === "AIR" ? (
                        <div className="col-md-6 col-12">
                          <div className="shpDetailsDivIdImg">
                            <div className="shpDetailsDivId">
                              <span>Flight</span>
                              <p>
                                {loadedData.Voyage ? loadedData.Voyage : "N/A"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : loadedData.TransportMode === "RAI" ? (
                        <div className="col-md-6 col-12">
                          <div className="shpDetailsDivIdImg">
                            <div className="shpDetailsDivId">
                              <span>Journey Ref#</span>
                              <p>
                                {loadedData.Vessal ? loadedData.Vessal : "N/A"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : loadedData.TransportMode !== "ROA" ? (
                        <div className="col-md-6 col-12">
                          <div className="shpDetailsDivIdImg">
                            <div className="shpDetailsDivId">
                              <span>Voyage</span>
                              <p>
                                {loadedData.Voyage ? loadedData.Voyage : "N/A"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {loadedData.TransportMode !== "AIR" ? (
                        <div className="col-md-6 col-12">
                          <div className="shpDetailsDivIdImg">
                            <div className="shpDetailsDivId">
                              <span>Container #</span>
                              <p title={loadedData.ContainerNumbers}>
                                {loadedData.ContainerNumbers
                                  ? loadedData.ContainerNumbers
                                  : "N/A"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerLeft: {
    width: "18%",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 6rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "18%",
    minWidth: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
  },
}));

export default SearchShipmentResult;
